import { render, staticRenderFns } from "./DjcReport.vue?vue&type=template&id=717a70b6&scoped=true&"
import script from "./DjcReport.vue?vue&type=script&lang=js&"
export * from "./DjcReport.vue?vue&type=script&lang=js&"
import style0 from "./DjcReport.vue?vue&type=style&index=0&id=717a70b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717a70b6",
  null
  
)

export default component.exports